import React from 'react';

function Minus() {
    return (
        <path d="M0.5,12.5h23c0.3,0,0.5-0.2,0.5-0.5s-0.2-0.5-0.5-0.5h-23C0.2,11.5,0,11.7,0,12S0.2,12.5,0.5,12.5z" />
    );
}

export default Minus;
